import { h } from "preact";
import { Card, Col, Row, Tooltip, Typography } from "antd";
import Icon, { InfoCircleOutlined } from "@ant-design/icons";

import OverviewInfoDataSource from "./OverviewInfoDataSource";
import useOverview from "./useOverview";


export default function OverviewSection() {

    const { overviewInfo, fetchOverviewInfo } = useOverview();
    const statsView = OverviewInfoDataSource(overviewInfo).asStatsView();

    return (
        <Row gutter={16}>
            {statsView.map(({ title, icon, textContent }) => (
                <Col span={8}>
                    <Card
                        bodyStyle={{ padding: "16px 30px" }}
                        bordered={false}
                        style={{ backgroundColor: "#fff" }}
                    >
                        <Row gutter={30}>
                            <Col>
                                <Icon
                                    height={40}
                                    component={icon}
                                    style={{ marginTop: "10px" }}
                                />
                            </Col>
                            <Col>
                                <Typography.Text>
                                    {title}
                                    <Tooltip title="tooltip">
                                        <InfoCircleOutlined
                                            style={{
                                                opacity: "0.5",
                                                paddingLeft: "8px"
                                            }}
                                        />
                                    </Tooltip>
                                </Typography.Text>
                                <Typography.Title
                                    style={{ margin: "0 0 4px 0" }}
                                    level={3}
                                >
                                    {textContent}
                                </Typography.Title>
                                <Typography.Text
                                    type="secondary"
                                >
                                    Total this month
                                </Typography.Text>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            ))}
        </Row>
    );
}
